import { createMultiValueReverseMap } from './variable-utils';
const colorMapping = {
  color_0: 'wst-base-1-color',
  color_1: 'wst-primary-background-color',
  color_2: 'wst-secondary-background-color',
  color_3: 'wst-system-disabled-color',
  color_4: 'wst-shade-3-color',
  color_5: 'wst-paragraph-2-color',
  color_6: 'wst-shade-1-color',
  color_7: 'wst-shade-2-color',
  color_8: 'wst-links-and-actions-color',
  color_9: 'wst-shade-3-color',
  color_10: 'wst-base-2-color',
  color_11: 'wst-primary-background-color',
  color_12: 'wst-secondary-background-color',
  color_13: 'wst-system-disabled-color',
  color_14: 'wst-shade-3-color',
  color_15: 'wst-paragraph-2-color',
  color_16: 'wst-shade-1-color',
  color_17: 'wst-shade-2-color',
  color_18: 'wst-links-and-actions-color',
  color_19: 'wst-shade-3-color',
  color_20: 'wst-base-2-color',
  color_21: 'wst-shade-1-color',
  color_22: 'wst-shade-2-color',
  color_23: 'wst-accent-2-color',
  color_24: 'wst-shade-3-color',
  color_25: 'wst-base-2-color',
  color_26: 'wst-shade-1-color',
  color_27: 'wst-shade-2-color',
  color_28: 'wst-accent-2-color',
  color_29: 'wst-shade-3-color',
  color_30: 'wst-base-2-color',
  color_31: 'wst-shade-1-color',
  color_32: 'wst-shade-2-color',
  color_33: 'wst-accent-2-color',
  color_34: 'wst-shade-3-color',
  color_35: 'wst-base-2-color',
  color_36: 'wst-base-1-color',
  color_37: 'wst-base-2-color',
  color_38: 'wst-shade-1-color',
  color_39: 'wst-shade-2-color',
  color_40: 'wst-shade-3-color',
  color_41: 'wst-accent-1-color',
  color_42: 'wst-accent-2-color',
  color_43: 'wst-accent-3-color',
  color_44: 'wst-accent-4-color',
  color_45: 'wst-heading-2-color',
  color_46: 'wst-heading-3-color',
  color_47: 'wst-paragraph-2-color',
  color_48: 'wst-button-primary-background-color',
  color_49: 'wst-button-primary-border-bottom-color',
  color_50: 'wst-button-primary-color',
  color_51: 'wst-button-primary-background-color',
  color_52: 'wst-button-primary-border-bottom-color',
  color_53: 'wst-button-primary-color',
  color_54: 'wst-system-disabled-color',
  color_55: 'wst-system-disabled-color',
  color_56: 'wst-button-primary-color',
  color_57: 'wst-button-secondary-background-color',
  color_58: 'wst-button-secondary-border-bottom-color',
  color_59: 'wst-button-secondary-color',
  color_60: 'wst-button-secondary-background-color',
  color_61: 'wst-button-secondary-border-bottom-color',
  color_62: 'wst-button-secondary-color',
  color_63: 'wst-system-disabled-color',
  color_64: 'wst-system-disabled-color',
  color_65: 'wst-button-secondary-color'
};
const fontPresetMapping = {
  Title: 'wst-heading-1-font',
  'Page-title': 'wst-heading-2-font',
  'Heading-XL': 'wst-heading-3-font',
  'Heading-L': 'wst-heading-4-font',
  'Heading-M': 'wst-heading-5-font',
  'Heading-S': 'wst-heading-6-font',
  'Body-L': 'wst-paragraph-1-font',
  'Body-M': 'wst-paragraph-2-font',
  'Body-S': 'wst-paragraph-3-font',
  'Body-XS': 'wst-paragraph-3-font',
  Menu: 'wst-paragraph-2-font'
};
const fontMapping = {
  font_0: 'wst-heading-1-font',
  font_1: 'wst-paragraph-2-font',
  font_2: 'wst-heading-2-font',
  font_3: 'wst-heading-3-font',
  font_4: 'wst-heading-4-font',
  font_5: 'wst-heading-5-font',
  font_6: 'wst-heading-6-font',
  font_7: 'wst-paragraph-1-font',
  font_8: 'wst-paragraph-2-font',
  font_9: 'wst-paragraph-3-font',
  font_10: 'wst-paragraph-3-font'
};
const wixColorToWixThemeVariableMap = {
  'wix-color_1': 'wst-primary-background-color',
  'wix-color_2': 'wst-secondary-background-color',
  'wix-color_4': 'wst-paragraph-3-color',
  'wix-color_5': 'wst-paragraph-2-color',
  'wix-color_8': 'wst-links-and-actions-color',
  'wix-color_26': 'wst-base-1-color',
  'wix-color_27': 'wst-base-2-color',
  'wix-color_28': 'wst-shade-1-color',
  'wix-color_29': 'wst-shade-2-color',
  'wix-color_30': 'wst-shade-3-color',
  'wix-color_31': 'wst-accent-1-color',
  'wix-color_32': 'wst-accent-2-color',
  'wix-color_33': 'wst-accent-3-color',
  'wix-color_34': 'wst-accent-4-color',
  'wix-color_35': 'wst-heading-2-color',
  'wix-color_36': 'wst-heading-3-color',
  'wix-color_38': 'wst-primary-background-color',
  'wix-color_40': 'wst-button-primary-color',
  'wix-color_47': 'wst-button-secondary-background-color'
};
export const getColorToWixThemeVariableMap = () => {
  /** Simplification for usability in less strict codebases */
  return colorMapping;
};
export const getWixColorToWixThemeVariableMap = () => {
  return wixColorToWixThemeVariableMap;
};
export const getFontToWixThemeVariableMap = () => fontMapping;
export const getFontPresetToWixThemeVariableMap = () => fontPresetMapping;
export const getWixThemeVariableToColorMap = () => createMultiValueReverseMap(colorMapping);
export const getWixThemeVariableToFontMap = () => createMultiValueReverseMap(fontMapping);
export const getWixThemeVariableToFontPresetMap = () => createMultiValueReverseMap(fontPresetMapping);
//# sourceMappingURL=legacy-mapping.js.map